/**
 * @generated SignedSource<<df3addec088b1b5fc873b3207aa3e61c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type WidgetTodoOverviewDisplayMode = "MEDIUM" | "MEDIUM_GROUPED";
export type CreateWidgetTodoOverviewInput = {
  categoryId: string;
  displayMode?: WidgetTodoOverviewDisplayMode | null;
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
  teamIds: ReadonlyArray<string>;
  title?: string | null;
};
export type WATodoOverviewMutation$variables = {
  input: CreateWidgetTodoOverviewInput;
  storecastId: string;
};
export type WATodoOverviewMutation$data = {
  readonly dashboard: {
    readonly createWidgetTodoOverview: {
      readonly id: string;
    };
  };
};
export type WATodoOverviewMutation = {
  response: WATodoOverviewMutation$data;
  variables: WATodoOverviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetTodoOverview",
        "kind": "LinkedField",
        "name": "createWidgetTodoOverview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WATodoOverviewMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WATodoOverviewMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e33eaa00a13e702a649d0634ce66da59",
    "id": null,
    "metadata": {},
    "name": "WATodoOverviewMutation",
    "operationKind": "mutation",
    "text": "mutation WATodoOverviewMutation(\n  $storecastId: ID!\n  $input: CreateWidgetTodoOverviewInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetTodoOverview(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d817da6a39e74ad023f60115b2bc607";

export default node;
